module.exports = {
  CARBONKIT: '1b277393-405f-4de3-876b-02eb376dd9c4',
  REDSERIES: 'd969d361-5e13-4ac5-81ab-8bbfab663de5'
};
